export default __webpack_public_path__ + "static/media/g5-grey.3f42755a.png";